import type { ReactNode } from 'react';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="nz-app">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
